import React, { FC, useState } from 'react';
import Box from '@mui/material/Box';
import MarkdownView from 'react-showdown';
import {text} from "./text/en"

//
export default function PrivacyPolicy(props: any) {
    return (
        <Box sx={{ color: "black", maxWidth: 900, margin: "auto", padding: "70px 20px 20px 20px" }}>
               <Box sx={{ minHeight: "600px", }}>
                    <MarkdownView
                        style={{ textAlign: "left", listStyleType: "none" }}
                        markdown={text}
                        options={{ tables: true, emoji: true }}
                    />
                </Box>
        </Box>
    );
}
